import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, identityClient } from '@wajeez-web/core/api-base';
import { thunkErrorHandler } from '@wajeez-web/core/utils';

export const contactUs: ApiMethod<Server.ContactUsInput, void> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_ContactUs_Client(
        undefined,
        identityClient
      );

      const response = await client.contactUs_post_V1(data);

      rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const contactUsPublic: ApiMethod<Server.ContactUsInput, void> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_ContactUs_Client(
        undefined,
        identityClient
      );

      const response = await client.contactUs_public_post_V1(data);

      rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const contactUsDataasDataTable: ApiMethod<
  Server.ContactUsDatatable,
  Server.TableOfContactUsColumns,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_ContactUs_Client(
        undefined,
        identityClient
      );

      const response = await client.admin_ContactUs_datatable_post_V1(data);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};
